<template>
  <div id="roleForm" class="form">
    <v-form v-if="loaded" ref="form" v-model="valid" lazy-validation>
      <v-select
        v-model="role.moduleId"
        label="Module"
        :required="false"
        :items="modules"
        item-text="name"
        item-value="id"
      />
      <v-text-field v-model="role.role" label="Role" :required="true" />
      <v-text-field v-model="role.name" label="Name" :required="false" />

      <div class="mt-4 d-flex justify-space-between">
        <v-btn @click="goBack"> Back </v-btn>
        <v-btn @click="handleSubmit" color="primary">
          {{ id ? "Update" : "Save" }}
        </v-btn>
        <span></span>
      </div>
    </v-form>
  </div>
</template>
    
<script>
import { getRole } from "@/services/role";

import { mapActions } from "vuex";
import { getAccountModules } from '@/services/module'

export default {
  props: ["id"],
  data() {
    return {
      loaded: false,
      valid: false,
      role: {
        relations: {},
        role: "",
        name: "",
        moduleId: null
      },
      modules: []
    };
  },
  created() {
    getAccountModules()
      .then( (resp) => {
        this.modules = resp.data.content;
      })

    this.setInstance();
  },
  methods: {
    ...mapActions("role", ["createRole", "updateRole"]),
    ...mapActions("messages", [
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage",
    ]),

    async handleSubmit() {
      if (this.id) {
        let role = this.role;
        delete role.relations;

        this.updateRole(role)
          .then((response) => {
            console.log(response);
            this.addSuccessMessage("Role was updated successfully");
            this.goBack();
          })
          .catch(() => {
            this.addErrorMessage("Error updating Role, please try again later");
          });
      } else {
        let role = this.role;
        delete role.relations;

        this.createRole(role)
          .then((response) => {
            console.log(response);
            this.addSuccessMessage("Role was created successfully");
            this.goBack();
          })
          .catch(() => {
            this.addErrorMessage("Error creating Role, please try again later");
          });
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    setInstance() {
      if (this.id) {
        this.role.id = this.id;
        getRole(this.id).then((response) => {
          let instance = response.data;
          for (let property in instance) {
            if (
              Object.prototype.hasOwnProperty.call(instance, property) &&
              Object.prototype.hasOwnProperty.call(this.role, property)
            ) {
              this.role[property] = instance[property];
            }
          }
          this.loaded = true;
        });
      } else {
        this.loaded = true;
      }
      this.setDependencies();
    },
    setDependencies() {},
  },
  components: {},
};
</script>
